import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a2cf06b"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-connector-item__image" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "audience-connector-item__name" };
const _hoisted_4 = { class: "audience-connector-item__container" };
const _hoisted_5 = {
    key: 0,
    class: "audience-connector-item__status"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, null, -1));
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "audience-connector-item__form-group" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    value: undefined,
    disabled: ""
};
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "audience-connector-item__form-group" };
const _hoisted_13 = ["value", "disabled"];
const _hoisted_14 = {
    value: "undefined",
    disabled: ""
};
const _hoisted_15 = { value: "false" };
const _hoisted_16 = { value: "true" };
const _hoisted_17 = { class: "audience-connector-item__form-group element--datepicker datepicker__integration-form" };
const _hoisted_18 = { class: "audience-connector-item__buttons" };
const _hoisted_19 = {
    key: 1,
    class: "audience-connector-item__buttons--actions"
};
import { ref, computed, watch, watchEffect } from 'vue';
import { disabledBackwardDates, disabledHours, disabledMinutes } from '@/utilities/datepicker';
import { useStore } from 'vuex';
import { dateTimeInverseFormat } from '@/utilities/constants';
import { getConnectorIcon } from '@/features/AudienceManager/utils';
import moment from 'moment';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceIntegrationsItem',
    props: {
        data: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const schedules = ref([
            { name: 'zero', value: 0 },
            { name: 'one', value: 1 },
            { name: 'two', value: 2 },
            { name: 'four', value: 4 },
            { name: 'six', value: 6 },
            { name: 'eight', value: 8 },
            { name: 'twelve', value: 12 },
            { name: 'day', value: 24 },
            { name: 'two-days', value: 48 },
            { name: 'seven-days', value: 168 },
            { name: 'fifteen-days', value: 360 },
            { name: 'thirty-days', value: 720 },
        ]);
        const isShowingScheduleSelectTooltip = ref(false);
        const isShowingHasDatetimeTooltip = ref(false);
        const getStartDatetime = ref('');
        const getHasDatetime = ref(false);
        const getSchedule = ref(0);
        const isEditableConnector = computed(() => !!props.data?.enabled);
        const isOmnichatAndIndividualApproach = computed(() => store.getters['audienceManager/isOmnichatAndIndividualApproach']);
        const isOmnichatAndNotEnabled = computed(() => {
            return props.data.alias === 'omnichat' && props.data.enabled;
        });
        const isIndividualApproach = computed(() => {
            return isOmnichatAndIndividualApproach.value
                ? i18n.global.t('audiences.omnichat.individual-approach')
                : i18n.global.t('audiences.omnichat.automatic-approach');
        });
        const onChangeHasDatetime = (event) => {
            const value = event.target.value;
            getHasDatetime.value = value === 'true';
        };
        const changeScheduleType = (event) => {
            const { name } = event.target.dataset;
            if (name === 'hasDatetime' && getHasDatetime.value) {
                getStartDatetime.value = moment().second(0).add(15, 'minutes').format(dateTimeInverseFormat);
            }
        };
        const disabledDatepickerHours = () => {
            return disabledHours(props.data?.startDatetime);
        };
        const disabledDatepickerMinutes = () => {
            return disabledMinutes(props.data?.startDatetime);
        };
        const switchConnectorState = () => {
            if (props.data?.enabled) {
                deactivateConnector();
            }
            else {
                openActivationModal();
            }
        };
        const openActivationModal = () => {
            store.commit('audienceManager/TOGGLE_ACTIVATE_INTEGRATION_MODAL', {
                isVisible: true,
                connector: props.data,
                instanceId: props.data.id,
            });
        };
        const deactivateConnector = () => {
            store.dispatch('audienceManager/deactivateIntegration', props.data);
            store.dispatch('audienceManager/updateIntegration', {
                alias: props.data.alias,
                enabled: 0,
                interval: 0,
                hasDatetime: false,
                startDatetime: '',
            });
        };
        watch([getSchedule, getHasDatetime, getStartDatetime], () => {
            const currentIntegration = {
                interval: getSchedule.value,
                hasDatetime: !!getHasDatetime.value,
                startDatetime: getHasDatetime.value ? getStartDatetime.value : '',
            };
            const hasChanged = currentIntegration.interval !== props.data.interval ||
                currentIntegration.hasDatetime !== props.data.hasDatetime ||
                currentIntegration.startDatetime !== props.data.startDatetime;
            if (hasChanged) {
                store.dispatch('audienceManager/updateIntegration', {
                    ...props.data,
                    ...currentIntegration,
                    editable: true,
                });
            }
        });
        watchEffect(() => {
            getHasDatetime.value = props.data.hasDatetime === true;
            getSchedule.value = props.data.interval ?? 0;
            getStartDatetime.value = props.data.startDatetime ?? '';
        });
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_date_picker = _resolveComponent("el-date-picker");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["audience-connector-item", { 'audience-connector-item--enabled': props.data?.enabled }])
            }, [
                _createElementVNode("figure", _hoisted_1, [
                    (props.data.alias)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _unref(getConnectorIcon)(props.data.alias),
                            alt: props.data.alias
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("p", null, _toDisplayString(props.data.name), 1),
                        (props.data?.enabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _hoisted_6,
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('item-active')), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (isOmnichatAndNotEnabled.value)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            innerHTML: isIndividualApproach.value,
                            class: "audience-connector-item__name--omnichat"
                        }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                ]),
                (props.data.alias !== 'omnichat' || (props.data.alias === 'omnichat' && !isOmnichatAndIndividualApproach.value))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["audience-connector-item__form", `${props.data?.alias} ${!isEditableConnector.value ? 'inactive' : ''}`])
                    }, [
                        _createVNode(_component_el_tooltip, {
                            visible: isShowingScheduleSelectTooltip.value,
                            "raw-content": true,
                            content: _ctx.$t('audiences.value-error'),
                            placement: "top",
                            "popper-class": "el--tooltip-error"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`audiences.integration.update`)), 1),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((getSchedule).value = $event)),
                                        class: "audience-connector-item__schedule",
                                        "data-name": "schedule",
                                        disabled: !isEditableConnector.value,
                                        onChange: changeScheduleType
                                    }, [
                                        _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('select')), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedules.value, (option, index) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: index,
                                                value: option.value
                                            }, _toDisplayString(_ctx.$t(`audiences.integration.schedule.${option.name}`)), 9, _hoisted_11));
                                        }), 128))
                                    ], 40, _hoisted_9), [
                                        [_vModelSelect, getSchedule.value]
                                    ])
                                ])
                            ]),
                            _: 1
                        }, 8, ["visible", "content"]),
                        _createVNode(_component_el_tooltip, {
                            visible: isShowingHasDatetimeTooltip.value,
                            "raw-content": true,
                            content: _ctx.$t('audiences.value-error'),
                            placement: "top",
                            "popper-class": "el--tooltip-error integration-form--tooltip"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("label", null, _toDisplayString(_ctx.$t(`audiences.integration.first-exportation`)), 1),
                                    _createElementVNode("select", {
                                        value: getHasDatetime.value ? 'true' : 'false',
                                        onChange: onChangeHasDatetime,
                                        class: "audience-connector-item__schedule",
                                        "data-name": "hasDatetime",
                                        disabled: !isEditableConnector.value
                                    }, [
                                        _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('select')), 1),
                                        _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('audiences.integration.on-save')), 1),
                                        _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t('audiences.integration.scheduled')), 1)
                                    ], 40, _hoisted_13)
                                ])
                            ]),
                            _: 1
                        }, 8, ["visible", "content"]),
                        _withDirectives(_createElementVNode("div", _hoisted_17, [
                            _createElementVNode("label", null, _toDisplayString(_ctx.$t(`audiences.integration.date`)), 1),
                            _createVNode(_component_el_date_picker, {
                                modelValue: getStartDatetime.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((getStartDatetime).value = $event)),
                                type: "datetime",
                                format: "YYYY-MM-DD HH:mm",
                                "value-format": "YYYY-MM-DD HH:mm",
                                clearable: false,
                                "disabled-date": _unref(disabledBackwardDates),
                                placeholder: _ctx.$tc('_select', 2),
                                "disabled-hours": disabledDatepickerHours,
                                "disabled-minutes": disabledDatepickerMinutes,
                                disabled: !isEditableConnector.value
                            }, null, 8, ["modelValue", "disabled-date", "placeholder", "disabled"])
                        ], 512), [
                            [_vShow, getHasDatetime.value]
                        ])
                    ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_18, [
                    (!isEditableConnector.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn audience-connector-item__buttons--enable",
                            onClick: switchConnectorState
                        }, _toDisplayString(_ctx.$tc('_activate', 2)), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("button", {
                                class: "disable",
                                onClick: switchConnectorState
                            }, _toDisplayString(_ctx.$tc('_deactivate', 2)), 1),
                            _createElementVNode("button", {
                                class: "btn",
                                onClick: openActivationModal
                            }, _toDisplayString(_ctx.$tc('_edit', 2)), 1)
                        ]))
                ])
            ], 2));
        };
    }
});
